import React, { Component } from 'react'
import styled from 'styled-components'
import Button from '../../common/Button'
import LoadingButton from '../../common/LoadingButton'
import CloseIcon from '../../common/icons/CloseIcon2'

const Container = styled.div`
  border: 1px solid #b4b5b6;
  background: white;
  border-radius: 5px;
  padding: 10px 30px 30px 30px;
  color: #666666;
  display: flex;
  flex-direction: column;
  height: 216px;
  width: 380px;
`
const Title = styled.h3`
color: #616165;
font-family: "Open Sans";
font-size: 16px;
letter-spacing: 0.41px;
line-height: 22px;
text-align: center;
margin-bottom: 50px;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
const Cancel = Button.extend`
  background: #b4b5b6;
  color: #56565A;
  margin-right: 25px;
`
const SaveChanges = styled(LoadingButton)`
  border-radius: 4px;
  background-color: #3399CC;
  margin-left: 25px;
  color: #FFFFFF;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.36px;
  line-height: 19px;
  text-align: center;
`
const ClickableIcon = styled.span`
  cursor: pointer;
  display: block;
  width: 25px;
  height: 25px;
  margin-left: 375px;
  margin-bottom: 30px;
`

export default class UnsavedConfirmationModal extends Component {
  constructor() {
    super()
    this.state = {
      isLoading: false
    }
  }

  onSaveChangesClicked = () => {
    const { onUnsavedTopic } = this.props

    onUnsavedTopic()
  }

  onNoSaveClicked = () => {
    const { onNoSaveTopic } = this.props

    onNoSaveTopic()
  }

  render() {
    const { toggleModal } = this.props
    const { isLoading } = this.state
    const title = 'Your new changes have not been saved yet. Would you like to save your changes?'

    return (
      <Container>
        <ClickableIcon onClick={toggleModal}>
          <CloseIcon color="#56565A" />
        </ClickableIcon>
        <Title>{title}</Title>
        <ButtonContainer>
          <Cancel onClick={this.onNoSaveClicked}>
            Do not save
          </Cancel>
          <SaveChanges
            loading={isLoading}
            onClick={this.onSaveChangesClicked}>
              Save
          </SaveChanges>
        </ButtonContainer>
      </Container>
    )
  }
}
